var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-select",
    _vm._b(
      {
        attrs: { value: _vm.value, options: _vm.options },
        on: {
          input: function(value) {
            return _vm.$emit("input", value)
          }
        }
      },
      "q-select",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }